import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getPortfolios } from 'services/RewardsService'
import { API_PAGINATION_LIMIT, API_PAGINATION_OFFSET } from 'utils/pagination'
import { TEN_MINUTES } from 'utils/utils'

interface UseRewardsPortfoliosQueryOptions {
  pageNumber?: number
  pageSize?: number
  enabled?: boolean
}

export const useRewardsPortfoliosQuery = (options?: UseRewardsPortfoliosQueryOptions) => {
  const {
    pageNumber = API_PAGINATION_OFFSET,
    pageSize = API_PAGINATION_LIMIT,
    enabled = true,
  } = options || {}

  return useQuery({
    queryKey: reactQueryKeys.rewardsPortfolios(pageNumber, pageSize),
    queryFn: () => getPortfolios({ pageNumber, pageSize }),
    staleTime: TEN_MINUTES,
    enabled,
  })
}
